import * as React from 'react'

import { Box, Button } from '@factorialco/deprecated-design-system'
import {
  DeleteEditTimesheetRequestDocument,
  UpdateEditTimesheetRequestMutationVariables,
} from 'generated/resources/graphql'
import { isEmpty } from 'lodash'

import { useFormContext } from 'modules/core/hooks/useForm'
import { useMutation } from 'modules/core/hooks/useMutation'
import i18n from 'modules/core/lib/i18n'

interface Props {
  onCloseModal: () => void
}

const ModalFooter = ({ onCloseModal }: Props) => {
  const form = useFormContext<UpdateEditTimesheetRequestMutationVariables>()

  const [deleteRequest] = useMutation(DeleteEditTimesheetRequestDocument, {
    extractorFn: (data) => data.attendanceMutations.deleteAttendanceEditTimesheetRequest,
    update(cache, { data }) {
      const request =
        data?.attendanceMutations.deleteAttendanceEditTimesheetRequest?.editTimesheetRequest

      cache.evict({
        id: cache.identify({ id: request?.id, __typename: 'AttendanceEditTimesheetRequest' }),
      })
    },
  })

  const onDelete = async () => {
    await deleteRequest({ variables: { id: form.values.id } })
    onCloseModal()
  }

  return (
    <Box flexDirection="row" justifyContent="flexStart" gap="s8" width="full">
      <Box>
        <Button onClick={onDelete}>{i18n.t('common.delete')}</Button>
      </Box>
      <Box justifyContent="flexEnd" flexDirection="row" gap="s8" width="full">
        <Button onClick={onCloseModal} type="secondary">
          {i18n.t('common.cancel')}
        </Button>
        <Button disabled={!isEmpty(form.errors)} onClick={() => form.handleSubmit()}>
          {i18n.t('common.save')}
        </Button>
      </Box>
    </Box>
  )
}

export default ModalFooter
